import { Status } from "app/api/models";

export default class StatusHelper {
  static getStatusName(status: Status) {
    switch (status) {
      case Status.BookedIn:
        return "Booked In";
      case Status.InCalibration:
        return "In Calibration";
      case Status.CalReportComplete:
        return "Cal Report Complete";
      case Status.AwaitingClientResponse:
        return "Awaiting Client Response";
      case Status.AwaitingRepair:
        return "Awaiting Repair";
      case Status.ReadyForDispatch:
        return "Ready For Dispatch";
      case Status.SalesToProductionHandover:
        return "Sales to Production Handover";
      default:
        return Status[+status].toString();
    }
  }
}
